import { lazy } from 'react';


export const NewsDetails = lazy(() => import('./NewsDetails'));
